import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import "./quizSettingsPage.css";
import { fetchThemeData, selectTheme } from "../../themeSlice";
import { getAdminQustions } from "../../functions/getAdminQuestions";
import { processQuestions } from "../../questionSlice";
import { selectAdminToken } from "../../sessionSlice";
import { useNavigate } from "react-router-dom";
import ColorPallet from "../color_pallet/colorPallet";
import { updateThemeData } from "../../functions/updateThemeData";
import CsvUploadModal from "../uploadCSV/uploadCSV";
import UploadIntro from "../uploadIntro/uploadIntro";
import Switch from "react-switch";

const QuizSettingsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminToken = useSelector(selectAdminToken);
  const [isIntroModelOpen, setisIntroModelOpen] = useState(false);
  // bring in all four values from your theme slice exactly as before
  const {
    availableThemes,
    currentTheme,
    status,
    data: themeData,
  } = useSelector((state) => state.theme);

  const [correctPoints, setCorrectPoints] = useState(1);
  const [wrongPoints, setWrongPoints] = useState(0);
  const [eachTime, setEachTime] = useState(60);
  const [noOfQuestion, setNoOfQuestion] = useState(10);
  const [shuffle, setShuffle] = useState(false);
  const [lifelines, setLifelines] = useState(false);
  const [expert, setExpert] = useState(false);
  const [doubleDip, setDoubleDip] = useState(false);
  const [flip, setFlip] = useState(false);
  const [fiftyFifty, setFiftyFifty] = useState(false);
  const [rows, setRows] = useState([]);
  const [allOptionsAvailable, setAllOptionsAvailable] = useState(true);
  const [canFlipEnable, setCanFlipEnable] = useState(true);

  useEffect(() => {
    async function fetchData() {
      console.log(themeData);
      if (themeData == null) return true;
      try {
        // console.log("trying to fetch responses",{ currentTheme, adminToken });
        const response = await getAdminQustions({
          currentTheme,
          token: adminToken,
        });
        console.log(response);
        const questions = response.questions || [];

        const formatted = questions.map((q, i) => ({
          id: q.id,
          no: i + 1,
          question: q.question_name,
          hint: q.question_hint || "-",
          correctAnswer:
            q.answer_id === 1
              ? q.option_one
              : q.answer_id === 2
              ? q.option_two
              : q.answer_id === 3
              ? q.option_three
              : q.answer_id === 4
              ? q.option_four
              : "",
          option1: q.option_one,
          option2: q.option_two,
          option3: q.option_three,
          option4: q.option_four,
        }));

        console.log(formatted);
        setRows(formatted);

        const hasMissingOptions = formatted.some(
          (q) =>
            (!q.option3 || q.option3.trim() === "") &&
            (!q.option4 || q.option4.trim() === "")
        );

        if (hasMissingOptions) {
          setAllOptionsAvailable(false);
        }

        console.log("formatted length", formatted.length);
        console.log("No of questions", themeData.noOfQuestion);
        if (formatted.length <= themeData.noOfQuestion) {
          setCanFlipEnable(false);
          console.log("flip connot enabled");
          // if (themeData.flip) {
          //   Swal.fire("Warning", "Flip lifeline required 1 extra question...", "info");
          // }
        }
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    }
    if (currentTheme && adminToken) fetchData();
  }, [currentTheme, adminToken, themeData]);

  console.log("themedata--- ", themeData);

  useEffect(() => {
    if (!themeData) return;
    console.log("data-----", themeData);
    setCorrectPoints(themeData.correctPoints ?? 1);
    setWrongPoints(themeData.wrongPoints ?? 0);
    setEachTime(themeData.eachTime ?? 60);
    setNoOfQuestion(themeData.noOfQuestion ?? 10);
    setShuffle(themeData.shuffle ?? false);
    setLifelines(themeData.lifelines ?? false);
    setExpert(themeData.expert ?? false);
    setDoubleDip(themeData.double ?? false);
    setFlip(themeData.flip ?? false);
    setFiftyFifty(themeData.fifty_fifty ?? false);
  }, [themeData, currentTheme]);

  useEffect(() => {
    dispatch(fetchThemeData({ themeId: currentTheme }));
  }, [dispatch]);

  // If every individual lifeline gets switched off, the master "Lifelines"
  // toggle no longer has anything to show on the player's lifelines page --
  // turn it off automatically instead of leaving it on with nothing under it.
  useEffect(() => {
    if (lifelines && !expert && !doubleDip && !flip && !fiftyFifty) {
      setLifelines(false);
    }
  }, [expert, doubleDip, flip, fiftyFifty]);

  // --- submit all ---
  const handleSubmit = async () => {

  const sanitize = (v, def, min = null, max = null) => {
    const n = parseInt(v, 10);
    if (Number.isNaN(n)) return def;
    if (min !== null && n < min) return min;
    if (max !== null && n > max) return max;
    return n;
  };

  const correctPointsToSend = sanitize(correctPoints, 1, 1, 100);
  const wrongPointsToSend = sanitize(wrongPoints, 1, 1, 100);
  const eachTimeToSend = (() => {
    const n = parseInt(eachTime, 10);
    if (Number.isNaN(n)) return 60; // empty -> 60
    return n < 5 ? 5 : n; // if <5 -> 5
  })();
  const noOfQuestionToSend = sanitize(noOfQuestion, 5, 5, 50)

    if (noOfQuestionToSend > rows.length) {
      Swal.fire(
        "Warning",
        `Number of questions to display (${noOfQuestionToSend}) is more than the number of questions added (${rows.length}). Add more questions or lower this count before saving.`,
        "info"
      );
      return;
    }

    const payload = {
      data: {
       correctPoints: correctPointsToSend,
       wrongPoints: wrongPointsToSend,
       eachTime: eachTimeToSend,
       noOfQuestion: noOfQuestionToSend,
        shuffle,
        lifelines,
        expert,
        double: doubleDip,
        flip,
        fifty_fifty: fiftyFifty,
      },
      currentTheme,
    };

    try {
      // // use the shared helper
      await updateThemeData({ payload, token: adminToken });
      Swal.fire("Success", "Settings saved!", "success");
      navigate("/admin/quiz-settings");
      window.location.reload();
      // onClose();
    } catch (e) {
      Swal.fire("Error", e.message || "Failed to save settings", "error");
    }
  };

  const triggerSetDoubleDip = (value) => {
    console.log("all options available", allOptionsAvailable);
    if (allOptionsAvailable) {
      setDoubleDip(value);
    } else {
      Swal.fire(
        "Warning",
        "Some questions has only 2 options filled. Please fill all Option to enable double dip.",
        "info"
      );
    }
  };

  const triggerSetFify = (value) => {
    console.log("all options available", allOptionsAvailable);
    if (allOptionsAvailable) {
      setFiftyFifty(value);
    } else {
      Swal.fire(
        "Warning",
        "Some questions has only 2 options filled. Please fill all Option to enable double dip.",
        "info"
      );
    }
  };

  const triggerFlipEnable = (value) => {
    console.log("set trigger flip", value);
    if (value) {
      if (canFlipEnable) {
        setFlip(value);
      } else {
        Swal.fire(
          "Warning",
          "Flip lifeline required 1 extra question...",
          "info"
        );
      }
    } else {
      setFlip(value);
    }
  };

  // Fires as soon as the admin finishes editing "No of questions to display"
  // (not just at final Save) so a flip+insufficient-questions mismatch is
  // caught immediately, matching the existing immediate warning triggerFlipEnable
  // already gives when the Flip switch itself is toggled.
  const handleNoOfQuestionBlur = () => {
    const n = parseInt(noOfQuestion, 10);
    if (Number.isNaN(n)) return;
    // Flip only requires its +1 question when the lifelines master toggle
    // is actually on -- a leftover flip=true from before the master was
    // switched off shouldn't still demand the extra question.
    if (lifelines && flip && rows.length < n + 1) {
      Swal.fire(
        "Warning",
        "Flip lifeline required 1 extra question. Currently your number of questions to display leaves no extra question available.",
        "info"
      );
    }
  };

  const triggerLifline = (checked) => {
    // console.log("all-options-available",allOptionsAvailable);
    // console.log("fiftyFifty",themeData.fifty_fifty);
    if(themeData.fifty_fifty && !allOptionsAvailable){
      Swal.fire(
        "Warning",
        "Some questions has only 2 options filled. Please fill all Option to enable double dip.",
        "info"
      );
      return true;
    }
    console.log("can filp enabled",themeData.flip);
    if(themeData.flip && !canFlipEnable){
       Swal.fire(
          "Warning",
          "Flip lifeline required 1 extra question...",
          "info"
        );
    }else{
         setLifelines(checked);
    }   
  };

  return (
    <>
      <div className="back-button-holder">
        <button
          className="back-button"
          onClick={() => navigate("/admin/questions")}
        >
          <i class="fa-solid fa-arrow-left"></i> Back
        </button>
      </div>
      <div className="rules-page-new">
        <div className="blue-tabs-container">
          <div className="blue-tabs"></div>
          <div className="blue-tabs"></div>
          <div className="blue-tabs blue-tabs-active"></div>
        </div>

        <div className="admin-tabs-holder-v2">
          <div className="tabs-main-title">Quiz Settings</div>
          <div className="admin-tab-container">
            <div className="admin-tab-title">
              <i class="fa-solid fa-gear"></i> &nbsp; Points Configuration
            </div>
            <div className="form-group-v1">
              <label>No of questions to display</label>
                <input
                  type="number"
                  min="5"
                  max="50"
                  value={noOfQuestion}
                  onChange={(e) => setNoOfQuestion(parseInt(e.target.value))}
                  onBlur={handleNoOfQuestionBlur}
                  placeholder="Correct Points"
                />
              <div className="code">* Min 5, Max 50</div>
            </div>
            <div className="form-group-v1">
              <label>Points for Correct Answer</label>
              <input
                type="number"
                min="1"
                max="100"
                value={correctPoints}
                onChange={(e) => setCorrectPoints(parseInt(e.target.value))}
                placeholder="Correct Points"
              />
              <div className="code">* Min 1, Max 100</div>
            </div>
            <div className="form-group-v1">
              <label>Points for incorrect Answer</label>
              <input
                type="number"
                min="1"
                max="100"
                value={wrongPoints}
                onChange={(e) => setWrongPoints(parseInt(e.target.value))}
              />
              <div className="code">* Min 1, Max 100</div>
            </div>
          </div>

          <div className="admin-tab-container">
            <div className="admin-tab-title">
              <i class="fa-solid fa-clock"></i> &nbsp; Time Settings
            </div>
            <div className="form-group-v1">
              <label>Time per question (seconds)</label>
              <input
                type="number"
                min="0"
                value={eachTime}
                onChange={(e) => setEachTime(parseInt(e.target.value))}
              />
            </div>
          </div>

          <div className="admin-tab-container">
            <div className="admin-tab-title">
              <i class="fa-solid fa-pen"></i> &nbsp; Question Settings
            </div>
            <div className="setting-toggle-single">
              <div className="form-group-v2">
                <label>Shuffle Questions</label>
                <Switch checked={shuffle} onChange={setShuffle} />
              </div>
            </div>
          </div>

          <div className="admin-tab-container">
            <div className="admin-tab-title-v1">
              <div>
                <i class="fa-solid fa-pen"></i> &nbsp; Lifelines{" "}
              </div>{" "}
              <Switch checked={lifelines} onChange={triggerLifline} />
            </div>

            <>
              <div
                className={`setting-row-v1 lifelines-toggle-v1 ${
                  !lifelines ? "setting-row-grayout" : ""
                }`}
              >
                <div className="setting-input-toggle-v1">
                  <input
                    type="checkbox"
                    checked={expert}
                    onChange={(e) => setExpert(e.target.checked)}
                  />
                  <label>Expert Advise</label>
                </div>
                <div className="setting-input-toggle-v1">
                  <input
                    type="checkbox"
                    checked={doubleDip}
                    onChange={(e) => triggerSetDoubleDip(e.target.checked)}
                  />
                  <label>Double Dip</label>
                </div>
                <div className="setting-input-toggle-v1">
                  <input
                    type="checkbox"
                    checked={flip}
                    onChange={(e) => triggerFlipEnable(e.target.checked)}
                  />
                  <label>Flip 1 Question</label>
                </div>
                <div className="setting-input-toggle-v1">
                  <input
                    type="checkbox"
                    checked={fiftyFifty}
                    onChange={(e) => triggerSetFify(e.target.checked)}
                  />
                  <label>50:50</label>
                </div>
              </div>
              <div className="setting-row lifelines-toggle"></div>
            </>
          </div>
          <div className="rules-action-holder">
            <button className="save-and-continue" onClick={handleSubmit}>
              Save Quiz Settings
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuizSettingsPage;
